export const timeUnits = [
    {
        id: 0,
        code: 'minutes',
        label: 'Minutes',
        multiplier: 1
    },
    {
        id: 1,
        code: 'hours',
        label: 'Hours',
        multiplier: 60
    },
    {
        id: 2,
        code: 'days',
        label: 'Days',
        multiplier: 1440
    },
    {
        id: 3,
        code: 'months',
        label: 'Months',
        multiplier: 43800
    },
    {
        id: 4,
        code: 'years',
        label: 'Years',
        multiplier: 525600
    }
];
